import classNames from "classnames"
import { pushDataLayer } from "@/lib/helpers/tagManager"
import HeadingLabel from "@/common/partials/headingLabel/headingLabel"
import Button from "@/components/common/button/button"
import Arrow from "@/components/common/icons/arrow"
import styles from "./member-blurb.module.css"

export default function MemberBlurb({
  tag,
  heading,
  CTATracking = null,
  button = "normal",
  buttonStyle,
  url
}) {
  return (
    <div className={classNames(styles.container, styles[buttonStyle])}>
      <HeadingLabel className="mb-2.5">{tag}</HeadingLabel>
      <div className={styles.holder}>
        <strong className={classNames(styles.heading, "h5")}>{heading}</strong>
        <Button
          className={styles.button}
          theme="green"
          href={url}
          ariaLabel={button}
          onClick={() => {
            if (CTATracking) {
              pushDataLayer(CTATracking)
            }
          }}
          tagName="a">
          {buttonStyle === "normal" && button}
          {buttonStyle === "small" && <Arrow className="w-5.5 h-auto" />}
        </Button>
      </div>
    </div>
  )
}
